import { errorTextColor, successTextColor, warningTextColor } from '../../common/constants';
import { ErrorLevel } from '../../models/';

export class GaugeColors {
    public static red = errorTextColor;
    public static orange = warningTextColor;
    public static green = successTextColor;
}

export interface BandDefinition {
    min: number;
    max: number;
    classed: string;
    level: ErrorLevel;
    message: string;
    color: string;
}

export class GaugeDefaultBands {
    public static getBands(type: string): BandDefinition[] {
        return [
            { min: 0, max: 0.05, classed: 'fill-success', level: ErrorLevel.Success, message: `Percentage of ${type} is Ok`, color: GaugeColors.green },
            { min: 0.05, max: 0.2, classed: 'fill-warn', level: ErrorLevel.Warning, message: `Percentage of ${type} is a bit too high`, color: GaugeColors.orange },
            { min: 0.2, max: 1, classed: 'fill-error', level: ErrorLevel.Error, message: `Percentage of ${type} is too high`, color: GaugeColors.red }
        ];
    }

}